module.exports = __webpack_public_path__ + "static/media/KaTeX_SansSerif-Bold.84299b01.woff";